import { apiBaseUrl, tokenStore } from '@greenrinse/ui';

/** Downloads an authenticated file endpoint (PDF/Excel/CSV) and saves it with the given name. */
export async function downloadAuth(path: string, name: string) {
  const res = await fetch(`${apiBaseUrl}${path}`, { headers: { Authorization: `Bearer ${tokenStore.get()?.accessToken ?? ''}` } });
  if (!res.ok) { alert('Download failed'); return; }
  const blob = await res.blob();
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); URL.revokeObjectURL(a.href);
}
